<template>
  <div>
    <vx-card class="mb-5" title="Learning & Resources">
      <p class="mb-5">
        Here is some important information you will need to know about these 3 jobs. Use the tabs
        below to view the information on the job(s) you are interested in.
      </p>
    </vx-card>
    <vs-tabs alignment="fixed" class="mb-5 no-padding overwrite-tabs">
      <vs-tab label="The Graphic Designer">
        <div class="py-2">
          <vx-card class="no-shadow">
            <h4 class="mb-5">A Day in the Life of a Freelance Graphic Designer</h4>
            <p class="mb-5">
              Here is an excellent insight into the daily workflow of 2 different young Australian
              freelance graphic designers.
            </p>
            <responsive-iframe-wrapper
              :video="intro_videos[1].video"
              :image="intro_videos[1].image"
            />
            <p class="mb-5 text-center">
              For more information on Jeremy, check out his Youtube channel
              <a
                href="https://www.youtube.com/channel/UCsKxAGJpOi-tsJK18MQ9Fbg"
                target="_blank"
                aria-label="Jeremy's YouTube channel (opens in a new tab)"
                >here</a
              >
            </p>

            <responsive-iframe-wrapper
              :video="intro_videos[2].video"
              :image="intro_videos[2].image"
            />
            <p class="mb-5 text-center">
              For more information on Rien, check out her Youtube channel
              <a
                href="https://www.youtube.com/channel/UCfbI0Evbng_-PQEF-HL2dgA"
                target="_blank"
                aria-label="Rien's YouTube channel (opens in a new tab)"
                >here</a
              >
            </p>

            <h4 class="mb-5">Graphic design is all around you!</h4>
            <p class="mb-5">
              Look around. Design is everywhere, from the clothes you wear to your morning Boost
              Juice cup to the advertising on the side of your bus, to the process of ordering your
              UberEATS.
            </p>
            <p class="mb-5">
              There is a strong future in this merging of creativity with strategy. The advertising
              industry, businesses, organisations, and even individuals depend on it.
            </p>
            <h4 class="mb-5">Graphic Design is the Eye Candy (or wow factor) of any promotion!</h4>
            <p class="mb-5">
              <strong>But…..</strong> it should also include the “Ohhhhh” of understanding as the
              eye and brain connect style and purpose. So, it is also about communication in getting
              a message, idea or feeling across.
            </p>

            <div class="vx-row mt-5 flex justify-center">
              <div class="vx-col xl:w-3/4 lg:w-2/3 w-full my-5">
                <h4 class="mb-5">Graphic Designers have many Specialisations</h4>
                <p class="mb-5">Some of which include:</p>
                <h4 class="mb-5">Visual identity graphic design</h4>
                <p class="mb-5">
                  Better known as Branding. It is the relationship between a business and their
                  audience.
                </p>

                <h4 class="mb-5">Marketing & advertising graphic design</h4>
                <p class="mb-5">
                  This engages people based on their wants, needs, awareness and satisfaction.
                </p>

                <h4 class="mb-5">User interface graphic design (UI)</h4>
                <p class="mb-5">
                  This is based on how a user interacts with a device or application and the
                  designer must balance aesthetic appeal with technical functionality.
                </p>
                <p class="mb-5">
                  UI designers specialize in desktop apps, mobile apps, web apps and games.
                </p>

                <h4 class="mb-5">Publication graphic design</h4>
                <p class="mb-5">
                  This means working with editors and publishers to create layouts with carefully
                  selected typography and accompanying artwork, which includes photography, graphics
                  and illustrations.
                </p>

                <h4 class="mb-5">Packaging graphic design</h4>
                <p class="mb-5">
                  Products require packaging to protect and prepare them for storage, distribution,
                  and sale.
                </p>
                <p class="mb-5">Design is important for the marketing aspect.</p>

                <h4 class="mb-5">Motion graphic design</h4>
                <p class="mb-5">
                  These are graphics that are in motion like, animation, audio, typography, imagery,
                  video and other effects that are used in online media, television and film.
                </p>

                <h4 class="mb-5">Environmental graphic design</h4>
                <p class="mb-5">
                  This visually connects people to places by making spaces more memorable,
                  interesting, informative or easier to navigate.
                </p>
              </div>
              <div class="vx-col xl:w-1/4 lg:w-1/3 w-full my-5">
                <img
                  src="@/assets/images/experiences/creativeindustries/graphic_design_side_image.jpg"
                  alt=""
                  class="mx-auto img-responsive"
                />
              </div>
            </div>

            <p class="mb-5">
              Note: The rapidly developing areas of digital media relating to the internet and
              multimedia business presentations are opening up new areas of employment for graphic
              designers.
            </p>
            <h4 class="mb-5">Some Basics</h4>
            <p class="mb-5">
              All graphic design, regardless of type, is based on five key elements:
            </p>
            <ul class="default-list">
              <li>Balance for stability and structure</li>
              <li>Hierarchy to create organization and direction</li>
              <li>Alignment to create a sharper, clearer outcome</li>
              <li>Repetition to unify and strengthen</li>
              <li>Contrast to generate impact and highlight important areas</li>
            </ul>

            <centered-image-wrapper
              :image="require('@/assets/images/experiences/creativeindustries/lr_1.png')"
              alt=""
            />

            <vs-collapse accordion>
              <vs-collapse-item>
                <div slot="header">Balance – Symmetry</div>
                <div class="overflow-hidden">
                  <img
                    src="@/assets/images/experiences/creativeindustries/balance_symmetry_175.jpg"
                    alt="Balance (Symmetry) example: a three-by-three grid of blue circles on green, with a white circle in the top-left and bottom-right corners mirroring each other."
                    class="my-2 ml-2 mb-2 float-right"
                  />
                  <p class="mb-5">
                    Balance is achieved when elements are distributed evenly in a design.
                    Symmetrical design is where an image or element is reflected over a central
                    axis, which means the image on either side of an imaginary line is mirrored. A
                    butterfly or human face is an example of symmetry. Symmetry can occur multiple
                    times in an image, and while we usually think of horizontal or vertical
                    symmetry, images can reflect over any angle. Symmetry can also occur when
                    elements rotate around a central point, like petals of a flower or spokes of a
                    bike wheel. This is called rotational or radial symmetry. While symmetry can be
                    a useful design principle to create order and stability in design, it tends to
                    be static and can make designs less interesting.
                  </p>
                </div>
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Balance – Tension</div>
                <div class="overflow-hidden">
                  <img
                    src="@/assets/images/experiences/creativeindustries/balance_tension_175.jpg"
                    alt="Balance (Tension) example: a large white circle in the top-left corner balanced by a small white circle in the bottom-right, on an orange background."
                    class="my-2 ml-2 mb-2 float-right"
                  />
                  <p class="mb-5">
                    Balance can also be achieved through using tension in design. This means that
                    the two sides to a design are different in some way, creating an imbalance. The
                    relationship between the different elements create ‘tension’ resulting in a
                    dynamic design which implies movement and is more interesting to look at. This
                    is also referred to as asymmetrical design. It can be as simple as positioning
                    the same image in different sizes on a page and using the blank or negative
                    space to balance the design, or it could be achieved using different elements
                    entirely. An example of this would be using a picture on one side and a block of
                    text on the other to achieve balance.
                  </p>
                </div>
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Hierarchy</div>
                <div class="overflow-hidden">
                  <img
                    src="@/assets/images/experiences/creativeindustries/hierarchy_175.jpg"
                    alt="Hierarchy example: four white circles stacked vertically on pink, decreasing in size from largest at the top to smallest at the bottom."
                    class="my-2 ml-2 mb-2 float-right"
                  />
                  <p class="mb-5">
                    Hierarchy gives organisation and direction to a design by placing elements in a
                    certain way to guide the eye to the most important visuals or information first.
                    For example, a larger picture will grab attention first, and large text will be
                    the first thing we read on a page. Newspapers use this principle for their
                    headlines where larger type is used to draw a reader’s attention. Size is one
                    way to emphasise important elements, but positioning can also establish
                    hierarchy. For example, in cultures that read left to right, it is usual to
                    start reading at the top of a page, so important information or design elements
                    would be placed there. Most websites use a ‘header’ area which might include
                    their logo and business information.
                  </p>
                </div>
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Alignment</div>
                <div class="overflow-hidden">
                  <img
                    src="@/assets/images/experiences/creativeindustries/alignment_175.jpg"
                    alt="Alignment example: four equal blue circles lined up in a straight vertical column on a yellow background."
                    class="my-2 ml-2 mb-2 float-right"
                  />
                  <p class="mb-5">
                    Alignment helps achieve a more visually appealing design as elements have a more
                    exact relationship with each other and the page. Designers use grid systems
                    which create a framework for design to help achieve this. The page is broken up
                    into columns and rows, and by laying out the design over a grid, elements such
                    as pictures, shapes or text can be lined up perfectly. Newspapers and magazines
                    are a good example of how a grid system works to align elements. Headlines and
                    images can be aligned across multiple columns of main text which creates a
                    cleaner and more orderly design.
                  </p>
                </div>
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Repetition</div>
                <div class="overflow-hidden">
                  <img
                    src="@/assets/images/experiences/creativeindustries/repetition_175.jpg"
                    alt="Repetition example: a row of three purple circles of decreasing size at the top of a light blue panel, repeated as three black circles at the bottom of a darker blue panel."
                    class="my-2 ml-2 mb-2 float-right"
                  />
                  <p class="mb-5">
                    Repetition is the repeated occurrence of elements. It is the perception that
                    parts of a design, or the elements are related based on similar factors, for
                    example, a similar colour, size or shape. An unbroken repetition of an element
                    or elements creates a pattern. Repetition and pattern can unify a design and
                    create recognition; however, it can also be useful to contrast other elements
                    against to draw attention.
                  </p>
                </div>
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Contrast</div>
                <div class="overflow-hidden">
                  <img
                    src="@/assets/images/experiences/creativeindustries/contrast_175.jpg"
                    alt="Contrast example: a red circle on a blue panel above a blue circle on a red panel, with the colours swapped between the two halves."
                    class="my-2 ml-2 mb-2 float-right"
                  />
                  <p class="mb-5">
                    Contrast occurs when the difference between elements of design are highlighted
                    in some way. The difference in size, shape or colour of elements can be
                    emphasized to draw attention to part of a design. This is useful when you need
                    to highlight important information or aspects of the design, for example, using
                    a larger or bold font in text or making one image in a repeated pattern larger
                    than the others. A black and white image with one element in colour will draw
                    attention to the coloured image first. Using contrast also creates a more
                    interesting design.
                  </p>
                </div>
              </vs-collapse-item>
            </vs-collapse>

            <table class="table default-table">
              <tr class="header">
                <th scope="col" colspan="2">Pros and Cons of Being a Graphic Designer</th>
              </tr>
              <tr class="subheader">
                <th scope="col" width="50%">Pros</th>
                <th scope="col" width="50%">Cons</th>
              </tr>
              <tr class="body">
                <td>
                  <u>1. Employment Options</u> - As a creative professional, you’ll have the option
                  of working in-house for a company or going it alone as a self-employed person.
                </td>
                <td>
                  <u>1. Boundaries</u> - Feedback and editing is an important part of the design
                  process, but sometimes clients can make excessive demands. It’s important to
                  establish professional boundaries.
                </td>
              </tr>
              <tr class="body">
                <td>
                  <u>2. Varied and Interesting</u> - You’ll get to use your creativity and tech
                  skills to solve a wide variety of interesting design problems.
                </td>
                <td>
                  <u>2. Undervaluing the Work</u> - Unfortunately, some clients have unrealistic
                  expectations about how complicated a project can be or how long it will take.
                </td>
              </tr>
              <tr class="body">
                <td>
                  <u>3. In Demand</u> - Graphic design skills are in high demand and this high
                  demand looks set to continue well into the future.
                </td>
                <td>
                  <u>3. Lots of Competition</u> - There are lots of freelancers and agencies all
                  competing for the same contracts, it can be difficult to get started in such a
                  competitive environment.
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
      </vs-tab>
      <vs-tab label="The Interior Designer">
        <div class="py-2">
          <vx-card class="no-shadow">
            <h4 class="mb-5">What Does an Interior Designer ACTUALLY Do?</h4>
            <p class="mb-5">
              The below video is a deeper dive into what it is an interior designer does!
            </p>
            <p class="mb-5">
              <strong>Please Note:</strong> some of the regulations mentioned in this video may be
              different in Australia but the information is still very useful regarding what
              responsibilities an interior designer has.
            </p>
            <responsive-youtube-wrapper
              :video="intro_videos[3].video"
              :image="intro_videos[3].image"
            />

            <h4 class="mb-5">The difference between an Interior Decorator and Interior Designer</h4>
            <p class="mb-5">
              There are distinct differences between the training and roles of interior designers
              and interior decorators.
            </p>
            <p class="mb-5">
              Interior Decorators are responsible for the cosmetic design and decoration of an
              existing interior space. They develop design concepts and colour schemes for clients’
              rooms.
            </p>
            <p class="mb-5">
              Interior Designers are broadly educated in all aspects of residential and commercial
              interior design. They are trained to be able to understand, plan and change the
              internal structure of a building, but not the architectural integrity.
            </p>

            <p class="mb-5">
              <strong
                >Just as a starting point to get a feel of this type of work, take a look at these 7
                types of interior design styles for the home.</strong
              >
            </p>

            <div class="vx-row flex items-center justify-center">
              <div
                class="vx-col w-full sm:w-full lg:w-1/2 mb-base"
                v-for="(item, index) in interior_designs"
                :key="index"
              >
                <vx-card>
                  <div slot="no-body">
                    <img :src="item.img" :alt="item.alt" class="responsive card-img-top" />
                  </div>
                  <h5 class="mb-2">{{ index + 1 }}. {{ item.title }}</h5>
                  <p class="text-grey">{{ item.desc }}</p>
                </vx-card>
              </div>
            </div>
            <p class="mb-5">
              Sourced from
              <a
                href="https://www.bhg.com.au/interior-decorating-styles-7-types-of-interior-design"
                target="_blank"
                >Better Homes and Gardens</a
              >
            </p>

            <table class="table default-table">
              <tr class="header">
                <th scope="col" colspan="2">Pros and Cons of Being an Interior Designer</th>
              </tr>
              <tr class="subheader">
                <th scope="col" width="50%">Pros</th>
                <th scope="col" width="50%">Cons</th>
              </tr>
              <tr class="body">
                <td>
                  <u>1. Use Your Creativity</u> - Being an interior designer encourages you to
                  exercise your creative impulse and imagination.
                </td>
                <td>
                  <u>1. Competitive</u> - In the beginning, you may have to compete with others on
                  price leaving small profit margins. As you become more established, you’ll be able
                  to charge clients more.
                </td>
              </tr>
              <tr class="body">
                <td>
                  <u>2. Interact with Others</u> - In this job, you’ll interact with and get to know
                  lots of interesting people.
                </td>
                <td>
                  <u>2. Difficult Clients</u> - Now and then, you’ll experience working with a
                  client who is very demanding and difficult to please.
                </td>
              </tr>
              <tr class="body">
                <td>
                  <u>3. Be Your Own Boss</u> - Many interior designers are self-employed, this gives
                  you the freedom to direct your own work.
                </td>
                <td>
                  <u>3. Long Hours</u> - Interior design can require working long hours to meet
                  client deadlines.
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
      </vs-tab>
      <vs-tab label="The Photographer">
        <div class="py-2">
          <vx-card>
            <h4 class="mb-5">A Day in the Life of AFL Photographer Michael Willson</h4>
            <p class="mb-5">
              A look behind the scenes of a sports photographer working an AFL game, particularly
              interesting for aspiring sports photographers, but there’s plenty of interest for any
              type of photography here too!
            </p>
            <div class="vx-row my-5 flex items-center justify-center">
              <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
                <button
                  type="button"
                  class="no-style img-click-button"
                  aria-label="Play video: A Day in the Life of AFL Photographer Michael Willson"
                  @click="showIframePopup(intro_videos[4].video)"
                >
                  <img
                    :src="intro_videos[4].image"
                    class="mx-auto img-responsive cursor-pointer"
                    alt=""
                  />
                </button>
              </div>
            </div>
            <h4 class="mb-5">Photography has many Specialisations</h4>
            <p class="mb-5">
              There are many different types of photography that you can earn money from!
            </p>
            <p class="mb-5">Some of which include:</p>
            <ul class="default-list">
              <li>Wedding Photography</li>
              <li>Event Photography</li>
              <li>Portrait Photography</li>
              <li>Product Photography</li>
              <li>Fine Art Photography</li>
              <li>Fashion Photography</li>
              <li>Architectural Photography</li>
              <li>Travel Photography</li>
              <li>Advertising or Lifestyle Photography</li>
              <li>Photojournalism</li>
              <li>Pet Photography</li>
              <li>Sports Photography</li>
              <li>Aerial Photography</li>
              <li>Scientific or Specialty Photography</li>
              <li>Stock Photography</li>
            </ul>

            <p class="mb-5">
              To have a look at some amazing photography examples visit this Digital Gallery on the
              Australian Photographic Society website.
            </p>
            <p class="mb-5"><strong>But wait…. There’s more!</strong></p>
            <p class="mb-5">
              Here is a great blog with nearly 50 different types of photography that provide a
              brief description of each and showcases some amazing examples!
            </p>
            <p class="mb-5">There are plenty of options for all sorts of creative flare.</p>

            <centered-image-wrapper
              :image="require('@/assets/images/experiences/creativeindustries/lr_31.png')"
              alt=""
            />
            <p class="mb-5">
              <a href="https://www.stocksy.com/blog/types-of-photography/" target="_blank"
                >https://www.stocksy.com/blog/types-of-photography/</a
              >
            </p>

            <table class="table default-table">
              <tr class="header">
                <th scope="col" colspan="2">Pros and Cons of Being a Photographer</th>
              </tr>
              <tr class="subheader">
                <th scope="col" width="50%">Pros</th>
                <th scope="col" width="50%">Cons</th>
              </tr>
              <tr class="body">
                <td>
                  <u>1. Flexibility</u> - As a freelance photographer, you’re free to organise your
                  work schedule as you see fit, including what type of assignments you take on.
                </td>
                <td>
                  <u>1. Expensive Kit</u> - As a professional photographer, you’ll need to purchase
                  quite a bit of expensive gear including cameras, lenses, tripods, drones, etc.
                </td>
              </tr>
              <tr class="body">
                <td>
                  <u>2. Do What You Love</u> - Many photographers have a real passion for what they
                  do. If this is you, becoming a photographer will see you earning a living doing
                  what you love.
                </td>
                <td>
                  <u>2. No Guarantees</u> - Most photographers work on a freelance basis. As with
                  any type of freelancing, there is no guaranteed income.
                </td>
              </tr>
              <tr class="body">
                <td>
                  <u>3. Creativity</u> - Being a photographer won’t just enforce development on your
                  technical skills, it will also make develop your creativity too.
                </td>
                <td>
                  <u>3. Admin</u> - As a freelancer, you’ll most likely need to do paperwork such as
                  taxes, bookings, invoicing, promotion, etc.
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
      </vs-tab>
    </vs-tabs>
    <yt-video-popup v-if="showVideoPopupYt" :videoCode="ytVideoUrl"></yt-video-popup>
  </div>
</template>

<script>
import YtVideoPopup from '@/components/UI/YtVideoPopup';
import store from '@/store/store';

export default {
  components: { YtVideoPopup },
  data() {
    return {
      intro_videos: {
        1: {
          image: require('@/assets/images/experiences/creativeindustries/graphic_designer_1_splash.jpg'),
          video:
            $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
            '/content/creativeindustries/graphic_designer_1.mp4',
        },
        2: {
          image: require('@/assets/images/experiences/creativeindustries/graphic_designer_2_splash.jpg'),
          video:
            $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
            '/content/creativeindustries/graphic_designer_2.mp4',
        },
        3: {
          image: require('@/assets/images/experiences/creativeindustries/interior_designer_splash.jpg'),
          video: 'https://www.youtube.com/embed/O0sd20ABH4s',
        },
        4: {
          image: require('@/assets/images/experiences/creativeindustries/photographer_splash.jpg'),
          video: 'https://www.youtube.com/embed/KBkUzhPLokQ?autoplay=1',
        },
      },
      interior_designs: [
        {
          title: 'Scandinavian',
          desc: 'A simple but cosy house interior style',
          img: require('@/assets/images/experiences/creativeindustries/lr_11.png'),
          alt: 'Scandinavian-style living room: a white sofa with pale cushions, a sheepskin throw over a chair, a copper pendant light and a rustic timber coffee table against a white brick wall.',
        },
        {
          title: 'Hamptons',
          desc: 'Embraces a fresh, airy palette and natural textures.',
          img: require('@/assets/images/experiences/creativeindustries/lr_12.png'),
          alt: 'Hamptons-style living room: pale blue-grey sofas with patterned cushions, sheer white curtains, a glass coffee table and a cream patterned rug.',
        },
        {
          title: 'French provincial',
          desc: 'Defined by refined details, rustic textures and a washed-out colour palette.',
          img: require('@/assets/images/experiences/creativeindustries/lr_13.png'),
          alt: 'French provincial-style dining room: a timber table with weathered pale green chairs, a wrought-iron rack of wooden boards on the wall and a green enamel pendant light.',
        },
        {
          title: 'Mid-century modern',
          desc: 'Retro look that was popular in the 1950s and 1960s that has never gone out of fashion.',
          img: require('@/assets/images/experiences/creativeindustries/lr_14.png'),
          alt: 'Mid-century modern-style living room: plywood bookshelves, a brown leather sofa, a patterned rug and tall indoor plants beside a brick wall and floor-to-ceiling window.',
        },
        {
          title: 'Industrial',
          desc: 'An urban look with an edge, characterised by raw textures, exposed elements and metal fixtures and finishes.',
          img: require('@/assets/images/experiences/creativeindustries/lr_15.png'),
          alt: 'Industrial-style bathroom: raw concrete walls, exposed copper pipes with hanging bulb lights, a glass shower screen and black and white patterned floor tiles.',
        },
        {
          title: 'Eclectic',
          desc: 'Elements from various cultures, decorating styles and time periods, this style is highly personal in character.',
          img: require('@/assets/images/experiences/creativeindustries/lr_16.png'),
          alt: 'Eclectic-style living room: a dark teal panelled wall covered in a gallery of colourful artworks, a hanging plant, a cream sofa, coral armchairs and a black and white patterned rug.',
        },
        {
          title: 'Contemporary',
          desc: 'This design is constantly changing. Currently, the look is curved lines, neutral colours and minimalism.',
          img: require('@/assets/images/experiences/creativeindustries/lr_17.png'),
          alt: 'Contemporary-style living room: a round white coffee table with a grey vase, a small mug and a plant, in front of a grey sofa with a dark cushion, all in neutral tones.',
        },
      ],
      showVideoPopupYt: false,
      ytVideoUrl: false,
    };
  },
  provide: function () {
    return {
      closePopup: this.closePopup,
    };
  },
  methods: {
    showVideoFile(video) {
      store.dispatch('popup/showVideoPopup', video);
    },
    showVideoYt(url) {
      this.ytVideoUrl = url;
      this.showVideoPopupYt = true;
    },
    showIframePopup(url) {
      store.dispatch('popup/showIframePopup', url);
    },
    closePopup() {
      if (this.showVideoPopupFile) {
        this.videoURL = false;
        this.showVideoPopupFile = false;
      } else if (this.showVideoPopupYt) {
        this.ytVideoUrl = false;
        this.showVideoPopupYt = false;
      }
    },
  },
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
